import CafeteriaStatisticsSidebarFilterForm from './lib/filterForm';
import PanelBoxLayout from 'components/layout/panelBox';

import * as S from './styles';
import * as T from 'common/types';

interface IProps {
  cafeteriaList: T.Pages.CafeteriaListItem[];
}

export default function CafeteriaStatisticsSidebar({ cafeteriaList }: IProps) {
  return (
    <S.Content>
      <PanelBoxLayout icon="/icons/stroke/filter.svg" title="Filter">
        <CafeteriaStatisticsSidebarFilterForm cafeteriaList={cafeteriaList} />
      </PanelBoxLayout>
    </S.Content>
  );
}
